var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOffercat2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.9643 0H5.03571C2.25558 0 0 2.25558 0 5.03571V41.9643C0 44.7444 2.25558 47 5.03571 47H41.9643C44.7444 47 47 44.7444 47 41.9643V5.03571C47 2.25558 44.7444 0 41.9643 0ZM38.6071 26.4375C38.6071 27.1299 38.0406 27.6964 37.3482 27.6964H27.6964V37.3482C27.6964 38.0406 27.1299 38.6071 26.4375 38.6071H20.5625C19.8701 38.6071 19.3036 38.0406 19.3036 37.3482V27.6964H9.65179C8.95938 27.6964 8.39286 27.1299 8.39286 26.4375V20.5625C8.39286 19.8701 8.95938 19.3036 9.65179 19.3036H19.3036V9.65179C19.3036 8.95938 19.8701 8.39286 20.5625 8.39286H26.4375C27.1299 8.39286 27.6964 8.95938 27.6964 9.65179V19.3036H37.3482C38.0406 19.3036 38.6071 19.8701 38.6071 20.5625V26.4375Z",
    fill: "#CB202D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffercat2);
export default __webpack_public_path__ + "static/media/offercat2.1e0a70a07dab924b982ececb0f1fdcb2.svg";
export { ForwardRef as ReactComponent };